import {consumeHandover} from './utils/loginAsHandover.js'

// Imported first in Router.js: takes over a login-as token before socketio.js connects with sessionStorage.token
consumeHandover()
